import { render, staticRenderFns } from "./questions-answers.vue?vue&type=template&id=1a3e15c7"
import script from "./questions-answers.vue?vue&type=script&lang=js"
export * from "./questions-answers.vue?vue&type=script&lang=js"
import style0 from "./questions-answers.vue?vue&type=style&index=0&id=1a3e15c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports